// extracted by mini-css-extract-plugin
export var dropdownButton = "_18-0";
export var fullWidthDropdownButton = "_18-1";
export var icon = "_18-3";
export var iconPlaceholder = "_18-2";
export var menuItemRow = "_18-8";
export var separator = "_18-c";
export var shortcutContainer = "_18-7";
export var shortcutIconLg = "_18-6";
export var shortcutIconMd = "_18-5";
export var shortcutIconSm = "_18-4";
export var submenuChevron = "_18-b";
export var submenuDropdown = "_18-9";
export var submenuTriggerRow = "_18-a";